import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../forum/app';
import FormModal from '../../common/components/FormModal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import Form from '../../common/components/Form';
/**
 * The 'RenameDiscussionModal' displays a modal dialog with an input to rename a discussion
 */
export default class RenameDiscussionModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "discussion", void 0);
    _defineProperty(this, "currentTitle", void 0);
    _defineProperty(this, "newTitle", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.discussion = this.attrs.discussion;
    this.currentTitle = this.attrs.currentTitle;
    this.newTitle = Stream(this.currentTitle);
  }
  className() {
    return 'RenameDiscussionModal Modal--small';
  }
  title() {
    return app.translator.trans('core.forum.rename_discussion.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, m("div", {
      className: "Form-group"
    }, m("input", {
      className: "FormControl",
      bidi: this.newTitle,
      type: "text"
    })), m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('core.forum.rename_discussion.submit_button')))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    const title = this.newTitle();
    const currentTitle = this.currentTitle;

    // If the title is different to what it was before, then save it. After the
    // save has completed, update the post stream as there will be a new post
    // indicating that the discussion was renamed.
    if (title && title !== currentTitle) {
      return this.discussion.save({
        title
      }).then(() => {
        if (app.viewingDiscussion(this.discussion)) {
          app.current.get('stream').update().then(() => m.redraw());
        } else {
          m.redraw();
        }
        this.hide();
      }).catch(() => {
        this.loading = false;
        m.redraw();
      });
    } else {
      this.hide();
    }
  }
}
flarum.reg.add('core', 'forum/components/RenameDiscussionModal', RenameDiscussionModal);